import * as React from "react";
import { connect } from "react-redux";
import { Route, Redirect, RouteProps } from "react-router-dom";
import { Role } from "appz";
import { ApplicationState } from "store";
import { getIsAuthenticated, getRoles } from "user/store";

type ProtectedRoute = {
    component: React.ComponentClass | React.SFC;
    authenticated: boolean;
    userRoles: Array<Role>;
    roles?: Array<string>;
    redirectRoute?: string;
} & RouteProps;

const ProtectedRoute: React.SFC<ProtectedRoute> = ({
    component: Component,
    redirectRoute = "/",
    roles = [],
    authenticated,
    userRoles,
    ...rest
}) => (
    <Route
        {...rest}
        render={(props) => {
            if (!authenticated) {
                return <Redirect to={redirectRoute} />;
            }

            if (roles.length > 0) {
                const hasRole = userRoles.some((ur) =>
                    roles.some((r) => ur.name === r),
                );

                if (!hasRole) {
                    return <Redirect to={redirectRoute} />;
                }
            }

            return <Component {...props} />;
        }}
    />
);

const mapStateToProps = (state: ApplicationState) => ({
    authenticated: getIsAuthenticated(state),
    userRoles: getRoles(state),
});

export default connect(mapStateToProps)(ProtectedRoute);
